import { render } from "./FoodSafetyImg.vue?vue&type=template&id=093efa42&scoped=true"
import script from "./FoodSafetyImg.vue?vue&type=script&lang=js"
export * from "./FoodSafetyImg.vue?vue&type=script&lang=js"

import "./FoodSafetyImg.vue?vue&type=style&index=0&id=093efa42&scoped=true&lang=scss"

import exportComponent from "E:\\Project\\one-code-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093efa42"]])

export default __exports__